import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import Divider from 'material-ui/Divider'
import { List, ListItem } from 'material-ui/List'
import FlatButton from 'material-ui/FlatButton'
import MailOutline from 'material-ui/svg-icons/communication/mail-outline'
import Share from 'material-ui/svg-icons/social/share'
import facebook from '../../services/FacebookService'
import Page from '../common/page/Page'
import Poll from '../../models/Poll'
import './Send.less'

export default class Send extends React.Component {
	static handleClickSelection(event) {
		event.target.focus()
		event.target.setSelectionRange(0, 9999)
	}

	componentWillMount() {
		this.props.load()
	}

	componentDidMount() {
		this.facebook = facebook()
	}

	handleMailClick() {
		const subj = encodeURIComponent(this.props.poll.question)
		const body = encodeURIComponent(`Click here to vote:\n\n${this.props.poll.url}\n\n—\nCreate your own polls on\nhttps://sendpoll.com`)

		location.href = `mailto:?subject=${subj}&body=${body}`
	}

	handleFacebookClick() {
		this.facebook.then((FB) => {
			FB.ui({
				method: 'share',
				mobile_iframe: true,
				href: `https://sendpoll.com/${this.props.poll.id}`,
				quote: `Vote for "${this.props.poll.question}"`,
			})
		})
	}

	handleShareClick() {
		navigator.share({
			title: 'Sendpoll',
			text: `Vote for "${this.props.poll.question}"`,
			url: this.props.poll.url,
		})
	}

	render() {
		if (!this.props.poll) {
			return null
		}

		return (
			<Page className="send" title="Send">
				<p className="question">{this.props.poll.question}</p>
				<textarea
					className="url"
					defaultValue={this.props.poll.url}
					onClick={Send.handleClickSelection}
					readOnly
				/>
				<ol className="list numbered">
					<li>Tap the link and copy</li>
					<li>Paste to SMS, mail or social app</li>
					<li>Share with your friends</li>
				</ol>
				<Divider style={{ marginTop: '2em' }} />
				{ navigator.share !== undefined ? (
					<List>
						<ListItem
							leftIcon={<Share />}
							primaryText="Send…"
							onClick={() => this.handleShareClick()}
						/>
					</List>
				) : (
					<List>
						<ListItem
							leftIcon={<MailOutline />}
							primaryText="Send with e-mail"
							onClick={() => this.handleMailClick()}
						/>
						<ListItem
							leftIcon={<Share />}
							primaryText="Send with Facebook"
							onClick={() => this.handleFacebookClick()}
						/>
					</List>
				)}
				<div className="actions">
					<div className="p">
						<FlatButton
							label="See your polls"
							onClick={() => browserHistory.push('/polls')}
						/>
					</div>
				</div>
			</Page>
		)
	}
}

Send.propTypes = {
	load: PropTypes.func.isRequired,
	poll: PropTypes.instanceOf(Poll),
}

Send.defaultProps = {
	poll: null,
}



// WEBPACK FOOTER //
// ./src/components/send/Send.jsx